export default {
    gate_intro:
        'Log in to your MedMatch account to view them, create a temporary account, or continue as a guest with the access code from your email.',
    continue_as_guest: 'Continue as guest',
    log_in: 'Log in',
    create_account: 'Create account',
    back: 'Back',
    guest_code_hint: 'Enter the 6-digit access code from the share email or from the sender.',
    guest_code_placeholder: '000000',
    verify_code: 'Verify code',
    temp_account_intro: 'Create a temporary account to view these records. You will need to verify your email.',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    verify_email_hint: 'Enter the 6-digit verification code emailed to {email}.',
    verification_code: 'Verification code',
    verify_and_continue: 'Verify and continue',
    list_heading: 'Shared records ({count})',
    shared_by: 'Shared by {name}',
    available_until: 'Available until {date}',
    view: 'View',
    download: 'Download',
    preview_unavailable: "Preview isn't available for this file type.",
    revoked_heading: 'This link is no longer available',
    revoked_message: 'The provider who shared these documents has revoked access.',
    expired_heading: 'This link has expired',
    expired_message: 'Please ask the sender for a new link.',
    not_found_heading: 'Link not found',
    not_found_message: "This share link doesn't exist or was mistyped.",
    recipient_mismatch_heading: 'Wrong account',
    recipient_mismatch_message: 'This link was shared with {email}. Switch to that account to view the records.',
    another_email: 'another email address',
    switch_account: 'Switch account',
    errors: {
        code_invalid: 'Incorrect access code.',
        code_locked: 'Too many incorrect attempts. Ask the sender for a new share.',
        code_failed: 'Could not verify the access code. Try again.',
        email_taken: 'That email is already registered. Log in instead.',
        signup_failed: 'Could not create the account. Check your details and try again.',
        verify_failed: 'Verification failed. Check the code and try again.',
        load_failed: 'This link could not be opened right now.',
    },
}
